export const BOOKING_STEPS = {
  STEP_BASE_DATA: "STEP_BASE_DATA",
  STEP_PRICE_PACKAGE: "STEP_PRICE_PACKAGE",
  STEP_PREVIEWS_NEW: "STEP_PREVIEWS_NEW",
  STEP_BEWERBERHUB: "STEP_BEWERBERHUB",
  STEP_REVIEW: "STEP_REVIEW",
  STEP_FINISHED: "STEP_FINISHED",
  STEP_FINISHED_NEW: "STEP_FINISHED_NEW"
};

export const DISCOUNT_LIMIT = 1; // 100%
export const MAX_DECIMALS = 2; // 1.23
export const PICTURE_PRICE = 12; // EUR per picture
export const ADD_ON_PRICE = 49; // EUR per review
export const VIDEO_PRICE = 24; // EUR per video

// Taxes rates by country
export const SALES_TAXES_RATE = 0.19;

export const PAY_WITH_CREDIT = 0.8; // pay 80%
